import { Lock, Share2 } from "lucide-react";
import { toast } from "sonner";
import { API_BASE } from "@/lib/api";

const share = async (url, weeks, studio) => {
  try {
    const blob = await (await fetch(url)).blob();
    const file = new File([blob], `${weeks}-week-streak.svg`, { type: "image/svg+xml" });
    if (navigator.canShare?.({ files: [file] })) { await navigator.share({ files: [file], title: `${weeks}-week streak`, text: `${weeks} weeks straight with ${studio} 🔥` }); return; }
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
    toast.success("Badge saved");
  } catch { /* user cancelled */ }
};

export const BadgeWall = ({ clientId, streak, studio }) => {
  if (!streak) return null;
  const earned = streak.milestones.filter((m) => streak.best >= m);
  return (
    <div className="panel" data-testid="badge-wall">
      <div className="ph"><h3>Trophy cabinet</h3><span className="ss" data-testid="badge-wall-count">{earned.length}/{streak.milestones.length} earned · best streak {streak.best} wk</span></div>
      <div className="badge-grid">
        {streak.milestones.map((m) => {
          const hit = streak.best >= m;
          const url = `${API_BASE}/badge/${clientId}/${m}.svg`;
          return (
            <div className={`badge-tile ${hit ? "hit" : "locked"}`} key={m} data-testid={`badge-${m}`}>
              {hit ? <img src={url} alt={`${m}-week streak badge`} loading="lazy" /> : <div className="locked-face"><Lock size={22} strokeWidth={2.2} /><b className="num">{m}</b><small>weeks</small></div>}
              <div className="badge-meta">
                <b>{m}-week streak</b>
                <small>{hit ? "Earned" : `${Math.max(0, m - streak.current)} more week${m - streak.current === 1 ? "" : "s"} to unlock`}</small>
                {hit && <button type="button" className="btn sm g" onClick={() => share(url, m, studio)} data-testid={`badge-share-${m}`}><Share2 size={12} /> Share</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
